import { render, staticRenderFns } from "./AddPurchasesDeliveryComponent.vue?vue&type=template&id=35919adc"
import script from "./AddPurchasesDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./AddPurchasesDeliveryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports